import React, { Component } from 'react';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from '../styles.js';

class LeaderboardPopover extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const { classes, mobile, selected } = this.props;
    const mobileStyle = {
      position: 'fixed',
      bottom: 0,
      marginLeft: 0,
      marginRight: 0,
      marginBottom: 0,
      width: '100%',
      height: '85%'
    };
    const paperStyle = mobile ? mobileStyle : {};
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.dlClose}
        maxWidth="xl"
        PaperProps={{
          style: paperStyle
        }}
        BackdropProps={{
          style: {
            display: 'none'
          }
        }}
      >
        <DialogTitle>
          <Typography className={classes.dlTitle}>
            {mobile ? '' : 'Meet '}
            {selected.guest_name}'s Team
          </Typography>
          <Typography className={classes.dlScore}>
            {selected.fantasy_points}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Table stickyHeader className={classes.dlTable}>
            <TableHead className={classes.dlHead}>
              <TableRow>
                {mobile ? <></> : <TableCell className={classes.dlCell} />}
                <TableCell className={classes.dlLabel} align="left">
                  Name
                </TableCell>
                <TableCell className={classes.dlLabel} align="center">
                  Score
                </TableCell>
                {mobile ? <></> : <TableCell className={classes.dlCell} />}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.selections.map((selection, i) => {
                const visible = i < 4;
                return (
                  <TableRow>
                    {mobile ? <></> : <TableCell className={classes.dlCell} />}
                    <TableCell className={visible ? classes.dlCell : classes.dlOpaque} align="left">
                      {selection.option_name}
                    </TableCell>
                    <TableCell className={visible ? classes.dlCell : classes.dlOpaque} align="center">
                      {selection.points}
                    </TableCell>
                    {mobile ? <></> : <TableCell className={classes.dlCell} />}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.dlClose} className={classes.dlButton}>
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(useStyles)(LeaderboardPopover);
